import Vue from 'vue';
import App from './App.vue';
import "./styles/main.scss";

// Tell Vue to use the plugin
Vue.config.productionTip = false;

new Vue({
    render: h => h(App)
}).$mount("#app");

